
module.exports.add_loading_screen_SVG_ready_handler = (option={}) => {
    /*
        オプションなどは要検討
    */
    let { 
        fade_on="transitionend",
        wait_transition=false,
    } = option;

    let duration_to_fade=1000;
    document.querySelector('extern-svg#loading_screen_container').addEventListener('svgready',
        (e)=>{
            let DOM_loaded_svg=e.target.querySelector(':scope svg');
            
            // disable_animationクラスは、初回読み込み時とセクション画像のサイズが変動する時に
            // アニメーションを停止するためのもの

            // ただし、ローディング画像ではこの振る舞いをすると、アニメーションしなくなるので、
            // 当該クラスを外す仕様にする。

            // なお、ローディング画像表示中にセクション画像サイズの変動うんぬんは考慮にいれないことにする。
            DOM_loaded_svg.classList.remove('disable_animation');

            // FIXME:モード切り替えがいる
            // all_svg_readyを待ってローディングスクリーンをフェードアウトするか
            // ローディングアニメーションが終わった時点でフェードアウトするか

            const fade_loading_screen=(e)=>{
                let DOM_site_content_layer=document.querySelector('.row.site-content-layer');
                DOM_site_content_layer.classList.remove("opaque-on-open");
                DOM_loaded_svg.classList.add("fadeout");
            }

            switch(fade_on){
                case "transitionend":
                    DOM_loaded_svg.addEventListener("transitionend",
                        (e)=>{
                            setTimeout(fade_loading_screen,duration_to_fade);
                        }
                    );
                    break;
                case "all_svg_ready":
                    window.addEventListener('all_svg_ready',
                        (e)=>{
                            var timer_id;
                            //console.log("loaded.all");
                            
                            if(wait_transition){
                                timer_id = setTimeout(fade_loading_screen,duration_to_fade);
                                DOM_loaded_svg.addEventListener("transitionend",
                                    ()=>{
                                        clearTimeout(timer_id);
                                        fade_loading_screen();
                                    }
                                );
                            } else {
                                setTimeout(fade_loading_screen,duration_to_fade);
                            }
                        }
                    );
                    break;
            }

            DOM_loaded_svg.classList.add("action");

    
        }
    );

}